@use "@fukuri-admins/ui/layout" as *;

.displayNone {
  display: none;
}

.loaderWrapper {
  position: fixed;
  z-index: 99998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  overflow-y: scroll;
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modalRoot {
  padding: 30px 35px;
  box-sizing: border-box;
  width: 620px;
  height: fit-content;
  background: #fff;
  box-shadow: 0px 0px 30px rgba(55, 55, 79, 0.05);
  border-radius: 10px;
  text-align: center;
  margin: auto;
  @media (max-width: 769px) {
    min-width: 100% !important;
    width: 100% !important;
  }
}

.title {
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 1;
  margin-bottom: 24px;
  color: $Text;
}

.mainContainer {
  padding: 0px 50px;
}

.descContainer {
  color: $Text;
  font-weight: 400;
  font-size: 15px;
  line-height: 1.5;
  text-align: center;
  margin-top: 5px;
  margin-bottom: 5px;
}

.detailContainer {
  color: $Text;
  font-size: 15px;
  line-height: 1.5;
  text-align: left;
  margin-bottom: 32px;
}

.btnContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 570px) {
    display: block;
  }
}

.closeBtn {
  width: 100% !important;
  @media (max-width: 570px) {
    margin-left: 0px;
  }
}
